import { Component, Input, OnInit } from '@angular/core';
import { CourseService } from '../../services/course.service';
import { CoursePersistenceService } from '../../services/course-persistence.service';
import { ActivatedRoute } from '@angular/router';
import { SessionAttendee } from '../../models/sessionAttendee';

@Component({
  selector: 'app-session-attendee-quiz-result',
  templateUrl: './session-attendee-quiz-result.component.html',
  styleUrls: ['./session-attendee-quiz-result.component.scss']
})
export class SessionAttendeeQuizResultComponent implements OnInit{
  quizAnswers : any;
  quizData : any;
  isQuizReadOnly : boolean = false;
  topBarTitle : string ='Quiz Results'
 courseNumber : any;
  attendee : any;
  sessionId:any;
  sessionAttendees !:SessionAttendee[];
  constructor(private courseService : CourseService, private coursePersistenceService : CoursePersistenceService, private route: ActivatedRoute) {
    
  }
  ngOnInit(): void {
    this.courseNumber = this.route.snapshot.queryParamMap.get('courseNumber');
    this.attendee = this.route.snapshot.queryParamMap.get('attendee');
    this.sessionId = this.route.snapshot.queryParamMap.get('sessionId');
        this.courseService.getCourseProficiencyQuizDetails(this.courseNumber).subscribe((courseProficiencyQuiz)=>{
          this.quizData = courseProficiencyQuiz;
          this.courseService.getSessionAttendeeDetails(this.sessionId, this.attendee).subscribe((sessionAttendee)=>{
            this.sessionAttendees = sessionAttendee;
            this.quizData.quiz = sessionAttendee[0].quizQuestions;//Assigning particular session attendee attended Quiz questions that was saved during quiz taking
            this.quizAnswers = sessionAttendee[0].quizAnswers;
            this.isQuizReadOnly = true;
          });
        })
  }
}
